<template>
    <hts-tooltip reference-class="flex">
        <p>
            {{ getListLabelTypeNodeAndWarehouse(data, { between: '\n' }) }}
        </p>
        <template #reference>
            <span class="material-symbols-outlined text-xl">
                {{ getListLabelTypeNodeAndWarehouse(data) }}
            </span>
        </template>
    </hts-tooltip>
</template>
<script lang="ts" setup>
import { getListLabelTypeNodeAndWarehouse } from '~//fucntion/business/utils'
const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const data: any = ref()

onBeforeMount(() => {
  data.value = params?.value?.data.nodeTypes || []
})
</script>
fucntion/quote/status
